import { render, staticRenderFns } from "./PuzzleLoopEdit.vue?vue&type=template&id=12b060bc"
import script from "./PuzzleLoopEdit.vue?vue&type=script&lang=js"
export * from "./PuzzleLoopEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports